import { request, proto } from '@/main'

const customerApi = {}

customerApi.getCustomerList = query => {
  const pbReq = proto.create('fw.PBSearchCustomerListReq', query)
  return request('fw.customerSearch', pbReq, 'fw.PBMixCustomerList')
}

customerApi.getCustomerDetailById = id => {
  const pbReq = proto.create('framework.PBIntValue', { value: Number(id) })
  return request('fw.customerDetail', pbReq, 'fw.PBCustomerDetail')
}

customerApi.customerGetRecordById = id => {
  const pbReq = proto.create('framework.PBIntValue', { value: Number(id) })
  return request('fw.customerGetRecordById', pbReq, 'fw.PBCooperationRecordList')
}

customerApi.updateCustomer = query => {
  const pbReq = proto.create('fw.PBCustomer', query)
  return request('fw.customerUpdateInfo', pbReq)
}

customerApi.getContractById = id => {
  const pbReq = proto.create('framework.PBIntValue', { value: Number(id) })
  return request('fw.customerContractGetById', pbReq, 'fw.PBContract')
}

customerApi.getContractList = userId => {
  const pbReq = proto.create('framework.PBIntValue', { value: userId })
  return request('fw.customerContractList', pbReq, 'fw.PBContractList')
}

customerApi.addContract = query => {
  const pbReq = proto.create('fw.PBContract', query)
  return request('fw.customerContractAdd', pbReq)
}

customerApi.modifyContract = query => {
  const pbReq = proto.create('fw.PBContract', query)
  return request('fw.customerContractModify', pbReq)
}

customerApi.deleteContractById = id => {
  const pbReq = proto.create('framework.PBIntValue', { value: Number(id) })
  return request('fw.customerContractDelete', pbReq)
}

customerApi.getBillById = id => {
  const pbReq = proto.create('framework.PBIntValue', { value: Number(id) })
  return request('fw.customerBillGetById', pbReq, 'fw.PBBillInfo')
}

customerApi.getBillByUserId = userId => {
  const pbReq = proto.create('framework.PBIntValue', { value: Number(userId) })
  return request('fw.customerBillGetByUserId', pbReq, 'fw.PBBillInfo')
}

customerApi.modifyCustomerBill = query => {
  const pbReq = proto.create('fw.PBBillInfo', query)
  return request('fw.customerBillModifyBg', pbReq)
}

customerApi.addCustomerBill = query => {
  const pbReq = proto.create('fw.PBBillInfo', query)
  return request('fw.customerBillInfoAddBg', pbReq)
}

// 获取后台转账信息
customerApi.getCustomerBillTransferList = () => {
  return request('fw.customerBillTransferList', null, 'fw.PBReceiveAccountList')
}

customerApi.getCustomerContactById = id => {
  const pbReq = proto.create('framework.PBIntValue', { value: Number(id) })
  return request('fw.customerContactGetById', pbReq, 'fw.PBContact')
}

customerApi.getCustomerContactList = userId => {
  const pbReq = proto.create('framework.PBIntValue', { value: Number(userId) })
  return request('fw.customerContactList', pbReq, 'fw.PBContactList')
}

customerApi.addContact = query => {
  const pbReq = proto.create('fw.PBContact', query)
  return request('fw.customerContactAdd', pbReq)
}

customerApi.modifyContact = query => {
  const pbReq = proto.create('fw.PBContact', query)
  return request('fw.customerContactModify', pbReq)
}

customerApi.deleteContactById = id => {
  const pbReq = proto.create('framework.PBIntValue', { value: Number(id) })
  return request('fw.customerContactDelete', pbReq)
}

customerApi.getDeliveryAddressById = id => {
  const pbReq = proto.create('framework.PBIntValue', { value: Number(id) })
  return request('fw.customerDeliveryAddressGetById', pbReq, 'fw.PBDeliveryAddress')
}

customerApi.updateDeliveryAddress = query => {
  const pbReq = proto.create('fw.PBDeliveryAddress', query)
  return request('fw.customerDeliveryAddressUpdateBg', pbReq)
}

customerApi.getUserVisitRecordList = query => {
  const pbReq = proto.create('fw.PBGetReturnVisitRecordListReq', query)
  return request('fw.customerReturnVisitRecordList', pbReq, 'fw.PBReturnVisitRecordList')
}

customerApi.getReturnVisitRecordById = id => {
  const pbReq = proto.create('framework.PBLongValue', { value: Number(id) })
  return request('fw.customerReturnVisitRecordGetById', pbReq, 'fw.PBReturnVisitRecord')
}

customerApi.updateReturnVisitRecord = query => {
  const pbReq = proto.create('fw.PBReturnVisitRecord', query)
  return request('fw.customerReturnVisitRecordUpdate', pbReq)
}

customerApi.addVisitRecord = query => {
  const pbReq = proto.create('fw.PBReturnVisitRecord', query)
  return request('fw.customerReturnVisitRecordAdd', pbReq)
}

customerApi.deleteVisitRecord = id => {
  const pbReq = proto.create('framework.PBLongValue', { value: Number(id) })
  return request('fw.customerReturnVisitRecordDelete', pbReq)
}

customerApi.getCustomerById = id => {
  const pbReq = proto.create('framework.PBIntValue', { value: Number(id) })
  return request('fw.customerGetById', pbReq, 'fw.PBCustomer')
}

/**
 * 通过用户ID 获取客户详情
 * @param {int} userId
 */
customerApi.getCustomerDetailByUserId = userId => {
  const pbReq = proto.create('framework.PBIntValue', { value: Number(userId) })
  return request('fw.customerDetail', pbReq, 'fw.PBCustomerDetail')
}

customerApi.batchAddProduct = query => {
  const pbReq = proto.create('fw.PBBatchAddBoughtProductsReq', query)
  return request('fw.customerProductBatchAddBg', pbReq)
}

// 用户获取已购产品的续费详情，PBIntValue(productId)-->PBRenewal
customerApi.getRenewalByProductId = id => {
  const pbReq = proto.create('framework.PBIntValue', { value: Number(id) })
  return request('fw.renewalGetByProductId', pbReq, 'fw.PBRenewal')
}
// 根据id获取指定的续费详情，PBIntValue(renewalId)-->PBRenewal
customerApi.getRenewalById = id => {
  const pbReq = proto.create('framework.PBIntValue', { value: Number(id) })
  return request('fw.renewalGetById', pbReq, 'fw.PBRenewal')
}
// 更新备注，PBRenewal(renewalId,remark)-->void
customerApi.updateRenewalRemark = (id, remark) => {
  const pbReq = proto.create('fw.PBRenewal', { id: Number(id), remark })
  return request('fw.renewalUpdateRemark', pbReq)
}
// 后台根据状态获取续费任务列表，PBGetRenewalListReq-->PBRenewalList
customerApi.getRenewalList = query => {
  const pbReq = proto.create('fw.PBGetRenewalListReq', query)
  return request('fw.renewalListAdmin', pbReq, 'fw.PBRenewalList')
}
// 修改为续费成功，PBRenewSuccessReq-->void
customerApi.updateRenewalSuccess = query => {
  const pbReq = proto.create('fw.PBRenewSuccessReq', query)
  return request('fw.renewalRenewSuccess', pbReq)
}
// 修改为续费失败，PBRenewFailReq-->void
customerApi.updateRenewalFail = query => {
  const pbReq = proto.create('fw.PBRenewFailReq', query)
  return request('fw.renewalRenewFail', pbReq)
}
// 获取待审核的数量，void-->PBIntValue
customerApi.getRenewalPendingCount = () => {
  return request('fw.renewalPendingCount', null, 'PBIntValue')
}
// 修改失败分类，PBRenewal(renewalId,failType,failReason) --> void
customerApi.updateRenewalModifyFailType = (id, failType, failReason) => {
  const pbReq = proto.create('fw.PBRenewal', { id: Number(id), failType: Number(failType), failReason })
  return request('fw.renewalModifyFail', pbReq)
}
// 关闭续费任务，PBLongValue(renewal.Id) --> void
// customerApi.renewalClose = id => {
//   const pbReq = proto.create('framework.PBIntValue', { value: Number(id) })
//   return request('fw.renewalClose', pbReq)
// }

// 关闭续费任务，PBCloseRenewReq --> void
customerApi.renewalClose = param => {
  const pbReq = proto.create('fw.PBCloseRenewReq', param)
  return request('fw.renewalClose', pbReq)
}

// 修改续费任务的预流失
customerApi.renewalModifyPreLost = param => {
  const pbReq = proto.create('fw.PBModifyPreLostReq', param)
  return request('fw.renewalModifyPreLost', pbReq)
}

// 续费变更
customerApi.renewalChange = param => {
  const pbReq = proto.create('fw.PBChangeRenewReq', param)
  return request('fw.renewalChange', pbReq)
}

// 设置延期调用API时间
customerApi.renewalDelayApiTimeSet = param => {
  const pbReq = proto.create('fw.PBDelayApiTimeReq', param)
  return request('fw.renewalDelayApiTimeSet', pbReq)
}

// 获取历史备注
customerApi.getUserLogByCategory = query => {
  const pbReq = proto.create('fw.PBGetUserLogListReq', query)
  return request('fw.userLogGetByCategory', pbReq, 'fw.PBUserLogList')
}

// 获取置顶的历史备注
customerApi.getTopUserLog = query => {
  const pbReq = proto.create('fw.PBGetUserLogListReq', query)
  return request('fw.userLogGetTop', pbReq, 'fw.PBUserLogList')
}

// 设置某个历史备注置顶状态
customerApi.updateUserLogTopState = query => {
  const pbReq = proto.create('fw.PBUserLog', query)
  return request('fw.userLogUpdateTop', pbReq)
}

// 为用户添加备注
customerApi.addUserRemark = query => {
  const pbReq = proto.create('fw.PBAddUserRemarkReq', query)
  return request('fw.userAddRemarkBg', pbReq)
}

// 收入明细查询
customerApi.searchIncomeFinance = query => {
  const pbReq = proto.create('fw.PBSearchFinanceListReq', query)
  return request('fw.financeIncomeSearch', pbReq, 'fw.PBFinanceResultList')
}

// 手动发送通知，PBRenewalSendNotifyReq(renewalId,contacts required) --> void
customerApi.sendNotifyReq = (id, contacts) => {
  const pbReq = proto.create('fw.PBRenewalSendNotifyReq', { renewalId: Number(id), contacts })
  return request('fw.renewalSendNotify', pbReq)
}

// 收入明细 -> 手动关联合同
customerApi.bindFinanceIncomeContract = query => {
  const pbReq = proto.create('fw.PBFinance', query)
  return request('fw.financeIncomeBindContract', pbReq)
}

// 收入明细 -> 收款进度
customerApi.getFinanceIncomeProgress = query => {
  const pbReq = proto.create('fw.PBGetFinanceProgressReq', query)
  return request('fw.financeIncomeProgressGet', pbReq, 'fw.PBFinanceProgress')
}

// 收入明细 -> 更新备注
customerApi.updateFinanceIncomeRemark = query => {
  const pbReq = proto.create('fw.PBFinance', query)
  return request('fw.financeIncomeUpdateRemark', pbReq)
}
// 收入明细 -> 新增指标设置
customerApi.modifyIncomeTarget = query => {
  const pbReq = proto.create('fw.PBFinanceProgress', query)
  return request('fw.financeIncomeModifyTarget', pbReq)
}

// 收入统计接口
// 收入统计，void --> PBFinanceStatistics
// customerApi.getFinanceIncomeStatistics = () => {
//   return request('financeIncomeStatistics', null, 'PBFinanceStatistics')
// }

// FINANCE_INCOME_STATISTICS = 120003;                                 // 收入统计，PBIntValue(serviceType) --> PBFinanceStatistics

customerApi.getFinanceIncomeStatistics = serviceType => {
  const pbReq = proto.create('framework.PBIntValue', { value: Number(serviceType) })
  return request('fw.financeIncomeStatistics', pbReq, 'fw.PBFinanceStatistics')
}

// 收入统计查询趋势，PBSearchFinanceTrendStatisticsReq --> PBFinanceTrendStatistics
customerApi.getFinanceIncomeSearchTrend = query => {
  const pbReq = proto.create('fw.PBSearchFinanceTrendStatisticsReq', query)
  return request('fw.financeIncomeSearchTrend', pbReq, 'fw.PBFinanceTrendStatistics')
}

// 联系人 -> 设置为主对接人
customerApi.setPrimaryContact = query => {
  const pbReq = proto.create('fw.PBContact', query)
  return request('fw.customerContactSetPrimary', pbReq)
}

// 联系人 -> 获取主对接人
customerApi.getPrimaryContact = userId => {
  const pbReq = proto.create('framework.PBIntValue', { value: Number(userId) })
  return request('fw.customerContactGetPrimary', pbReq, 'fw.PBContact')
}

// 修改合同流转信息
customerApi.modifyContractCirculation = query => {
  const pbReq = proto.create('fw.PBContract', query)
  return request('fw.customerContractModifyCirculation', pbReq)
}

// 将RenewalID转为字符串
customerApi.convertIdToStr = id => {
  const pbReq = proto.create('framework.PBLongValue', { value: Number(id) })
  return request('fw.renewalIdConvert', pbReq, 'PBStrValue')
}

// 修改续费任务的月份
customerApi.modifyRenewalTaskDate = query => {
  const pbReq = proto.create('fw.PBRenewal', query)
  return request('fw.renewalModifyTaskDate', pbReq)
}

customerApi.customerContractGetLatest = () => {
  return request('fw.customerContractGetLatest', null, 'PBStrValue')
}

customerApi.submitBillInfo = billInfo => {
  const pbReq = proto.create('fw.PBBillInfo', billInfo)
  return request('fw.customerBillSubmitBg', pbReq, 'PBIntValue')
}

// 文档格式
customerApi.userProductGetDocFormat = userProductid => {
  const pbReq = proto.create('PBIntValue', { value: Number(userProductid) })
  return request('fw.userProductGetDocFormat', pbReq, 'PBDocFormatList')
}

customerApi.userProductSetDocFormat = query => {
  const pbReq = proto.create('fw.PBDocFormatReq', query)
  return request('fw.userProductSetDocFormat', pbReq)
}

export default customerApi



// WEBPACK FOOTER //
// ./src/api/customer.js